import React, { FC } from 'react';

import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { Formik, useFormikContext } from 'formik';

import { CreatePurchaseOrderModalViewProps } from './CreatePurchaseOrderModal.props';
import CreatePurchaseOrderForm from './CreatePurchaseOrderForm';
import {
  CreatePurchaseOrderFormValues,
  getInitialValues,
  isPurchaseOrderFormValid,
} from './CreatePurchaseOrderModal.utils';

type FooterProps = {
  onClose: () => void;
  isCreatingPurchaseOrder: boolean;
};

const CreatePurchaseOrderFooter: FC<FooterProps> = ({
  onClose,
  isCreatingPurchaseOrder,
}) => {
  const {
    values,
    isSubmitting,
  } = useFormikContext<CreatePurchaseOrderFormValues>();

  return (
    <Flex mt={6} justify="center" gap={3} flexShrink={0}>
      <Button
        w="134px"
        variant="outline"
        isDisabled={isSubmitting || isCreatingPurchaseOrder}
        onClick={onClose}>
        Cancel
      </Button>
      <Button
        w="134px"
        type="submit"
        form="create-purchase-order-form"
        isDisabled={!isPurchaseOrderFormValid(values)}
        isLoading={isSubmitting || isCreatingPurchaseOrder}>
        Create PO
      </Button>
    </Flex>
  );
};

const CreatePurchaseOrderModalView: FC<CreatePurchaseOrderModalViewProps> = (
  props,
) => {
  const {
    isOpen,
    onClose,
    formResetKey,
    onCreatePurchaseOrder,
    isCreatingPurchaseOrder,
  } = props;

  const handleSubmit = async (values: CreatePurchaseOrderFormValues) => {
    await onCreatePurchaseOrder(values);
  };

  return (
    <Modal
      size="6xl"
      isCentered
      isOpen={isOpen}
      onClose={onClose}
      scrollBehavior="outside">
      <ModalOverlay />
      <ModalContent
        borderRadius="10px"
        maxW="1200px"
        maxH="90vh"
        display="flex"
        flexDirection="column"
        overflow="hidden">
        <ModalCloseButton _focus={{ outline: 'none' }} />
        <ModalHeader mt={5} textAlign="center" flexShrink={0}>
          Create Purchase Order
        </ModalHeader>
        <ModalBody
          pb={8}
          flex="1"
          display="flex"
          flexDirection="column"
          overflow="hidden"
          minH={0}>
          <Formik
            key={formResetKey}
            initialValues={getInitialValues()}
            onSubmit={handleSubmit}>
            <Flex direction="column" flex="1" minH={0} overflow="hidden">
              <CreatePurchaseOrderForm {...props} />
              <CreatePurchaseOrderFooter
                onClose={onClose}
                isCreatingPurchaseOrder={isCreatingPurchaseOrder}
              />
            </Flex>
          </Formik>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default CreatePurchaseOrderModalView;
